import * as React from "react";
const BankIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        width="48px"
        height="48px"
        {...props}
    >
        <path d="M12 2L1 7v2h22V7L12 2zm0 2.5L19.74 7H4.26L12 4.5zM5 9h2v9H5V9zm4 0h2v9H9V9zm4 0h2v9h-2V9zm4 0h2v9h-2V9zM3 20h18v2H3v-2z" />
    </svg>
);
export default BankIcon;
